// extracted by mini-css-extract-plugin
export default {"auth":"AuthForm_auth__2tjE+","control":"AuthForm_control__v2zSf","actions":"AuthForm_actions__4VJji","toggle":"AuthForm_toggle__O4n8w"};